export const columns = [
  {
    field: "id",
    headerName: "کد تیم",
    width: 150,
  },
  {
    field: "team",
    headerName: "نام تیم",
    width: 150,
  },
  {
    field: "assist",
    headerName: "تعداد پاس گل",
    width: 150,
  },
  {
    field: "defense",
    headerName: "تعداد دفاع",
    width: 150,
  },
  {
    field: "duel",
    headerName: "تعداد دوئل",
    width: 150,
  },
  {
    field: "gkMoves",
    headerName: "حرکت دروازه بان",
    width: 150,
  },
  {
    field: "goal",
    headerName: "تعداد گل",
    width: 150,
  },
  {
    field: "pass",
    headerName: "تعداد پاس",
    width: 150,
  },
  {
    field: "save",
    headerName: "تعداد سیو",
    width: 150,
  },
  {
    field: "shot",
    headerName: "تعداد شوت",
    width: 150,
  },
  {
    field: "skill",
    headerName: "امتیاز مهارت",
    width: 150,
  },
  {
    field: "woodWork",
    headerName: "ضربات به چوب دروازه",
    width: 150,
  },
  {
    field: "grandTotal",
    headerName: "مجموع کل",
    width: 150,
  },
];

export const rows = [
  {
    id: 1,
    team: "فوتبال U23",
    assist: 1,
    defense: 23,
    duel: 20,
    gkMoves: 6,
    goal: 2,
    pass: 31,
    save: 5,
    shot: 13,
    skill: 9,
    woodWork: 9,
    grandTotal: 110,
  },
  {
    id: 2,
    team: "فوتسال U19",
    assist: 3,
    defense: 39,
    duel: 17,
    gkMoves: 5,
    goal: 6,
    pass: 32,
    save: 8,
    shot: 15,
    skill: 6,
    woodWork: 8,
    grandTotal: 128,
  },
  {
    id: 3,
    team: "فوتسال U21",
    assist: 2,
    defense: 15,
    duel: 9,
    gkMoves: 9,
    goal: 1,
    pass: 24,
    save: 5,
    shot: 11,
    skill: 7,
    woodWork: 5,
    grandTotal: 75,
  },
  {
    id: 4,
    team: "فوتبال U19",
    assist: 1,
    defense: 11,
    duel: 5,
    gkMoves: 2,
    goal: 1,
    pass: 15,
    save: 8,
    shot: 4,
    skill: 4,
    woodWork: 4,
    grandTotal: 31,
  },
  {
    id: 5,
    team: "تراکتورسازی",
    assist: 5,
    defense: 32,
    duel: 17,
    gkMoves: 6,
    goal: 4,
    pass: 19,
    save: 7,
    shot: 5,
    skill: 8,
    woodWork: 6,
    grandTotal: 107,
  },
  {
    id: 6,
    team: "شاهین شهرداری",
    assist: 3,
    defense: 22,
    duel: 13,
    gkMoves: 4,
    goal: 2,
    pass: 30,
    save: 5,
    shot: 11,
    skill: 5,
    woodWork: 4,
    grandTotal: 99,
  },
  {
    id: 7,
    team: "فولاد خوزستان",
    assist: 7,
    defense: 29,
    duel: 15,
    gkMoves: 7,
    goal: 3,
    pass: 26,
    save: 6,
    shot: 9,
    skill: 6,
    woodWork: 5,
    grandTotal: 165,
  },
  {
    id: 8,
    team: "آلومینیوم اراک",
    assist: 4,
    defense: 40,
    duel: 20,
    gkMoves: 8,
    goal: 1,
    pass: 18,
    save: 5,
    shot: 10,
    skill: 7,
    woodWork: 8,
    grandTotal: 150,
  },
  {
    id: 9,
    team: "پرسپولیس U23",
    assist: 6,
    defense: 31,
    duel: 16,
    gkMoves: 6,
    goal: 2,
    pass: 33,
    save: 4,
    shot: 6,
    skill: 8,
    woodWork: 4,
    grandTotal: 125,
  },
  {
    id: 10,
    team: "استقلال U19",
    assist: 5,
    defense: 28,
    duel: 18,
    gkMoves: 5,
    goal: 3,
    pass: 27,
    save: 6,
    shot: 7,
    skill: 7,
    woodWork: 6,
    grandTotal: 140,
  },
  {
    id: 11,
    team: "سایپا",
    assist: 4,
    defense: 35,
    duel: 14,
    gkMoves: 7,
    goal: 3,
    pass: 30,
    save: 5,
    shot: 8,
    skill: 6,
    woodWork: 7,
    grandTotal: 130,
  },
  {
    id: 12,
    team: "سپاهان",
    assist: 3,
    defense: 37,
    duel: 16,
    gkMoves: 8,
    goal: 5,
    pass: 29,
    save: 7,
    shot: 10,
    skill: 8,
    woodWork: 6,
    grandTotal: 170,
  },
  {
    id: 13,
    team: "مس رفسنجان",
    assist: 6,
    defense: 25,
    duel: 19,
    gkMoves: 6,
    goal: 4,
    pass: 28,
    save: 7,
    shot: 9,
    skill: 7,
    woodWork: 5,
    grandTotal: 150,
  },
  {
    id: 14,
    team: "شهر خودرو",
    assist: 4,
    defense: 33,
    duel: 18,
    gkMoves: 6,
    goal: 2,
    pass: 31,
    save: 6,
    shot: 7,
    skill: 7,
    woodWork: 5,
    grandTotal: 140,
  },
  {
    id: 15,
    team: "نفت مسجد سلیمان",
    assist: 3,
    defense: 29,
    duel: 15,
    gkMoves: 5,
    goal: 1,
    pass: 26,
    save: 4,
    shot: 8,
    skill: 6,
    woodWork: 6,
    grandTotal: 120,
  },
];
